import { formats } from '@comall-backend-builder/types';

/**
 * 批量配置移动端详情（只读）——提交时不回传
 */
export class BatchDetailAppFormat extends formats.ObjectNoValidationFormat {
    formatParams(_key: string, _value: any) {
        return {};
    }
}
